// extracted by mini-css-extract-plugin
export default {"xxGridActionPanel":"Form_xxGridActionPanel__04PCR","HistoryForm":"Form_HistoryForm__LAe+Y"};